module.exports = __webpack_public_path__ + "/aa1af632841550199ebdf0c3cc1e47a6.ttf";